import React, { useEffect, useState } from 'react';
import { axiosClient } from 'api/axiosClient';
import { appConfig } from 'config/appConfig';
import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';
import { toNumber } from 'utils/toNumber';

type Props = {
  children: JSX.Element | JSX.Element[];
};

export const Auth: React.FC<Props> = ({ children }: Props) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const { pathname, search } = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (isAuthenticated) return;

    const queryParams = queryString.parse(search);

    const dataEnvironmentId = toNumber(queryParams.dataEnvironmentId);
    let jwt = queryParams.jwt as string;
    let returnUrl;

    const requestedUrl = queryString.stringifyUrl({
      url: pathname,
      query: {
        ...queryParams,
        dataEnvironmentId: undefined,
        jwt: undefined,
      },
    });

    if (dataEnvironmentId) {
      sessionStorage.setItem('dataEnvironmentId', dataEnvironmentId.toString());
    }

    if (jwt) {
      sessionStorage.setItem('jwt', jwt);
      returnUrl = sessionStorage.getItem('returnUrl');
      sessionStorage.removeItem('returnUrl');
    } else {
      jwt = sessionStorage.getItem('jwt') as string;

      if (!jwt) {
        sessionStorage.removeItem('jwt');
        sessionStorage.setItem('returnUrl', requestedUrl);
        window.location.href = appConfig.loginUrl;
        return;
      }
    }

    axiosClient.defaults.headers['Authorization'] = `Bearer ${jwt}`;

    setIsAuthenticated(true);

    const routeState = { ...queryParams, jwt };
    history.replace(returnUrl ? returnUrl : requestedUrl, routeState);
  }, [history, isAuthenticated, pathname, search]);

  return isAuthenticated ? <>{children}</> : null;
};

export default Auth;
